import { caseFilterhash } from '@debbie/common/dist/insights/index.js';
import { h } from '../index.js';
import { clearFilter } from './actions.js';
import filterBadges from './filterBadges.js';
export const selectCaseFilterCount = (state) => {
    const caseFilter = caseFilterhash(state.caseFilter);
    const count = state.caseFilterCount[caseFilter];
    if (!h.hasData(count)) {
        return null;
    }
    return count.data.count;
};
export const selectBadgesToShow = (_caseFilter) => (state) => {
    const lang = state.lang;
    const _stateCaseFilter = state.caseFilter;
    const caseFilter = _caseFilter || _stateCaseFilter;
    const badges = [];
    Object.keys(caseFilter).forEach((key) => {
        const filter = caseFilter[key];
        if (Array.isArray(filter) && filter.length === 0) {
            return;
        }
        if (typeof filter === 'object' && !Array.isArray(filter)) {
            if (typeof filterBadges[key] === 'object') {
                Object.keys(filter).forEach((childKey) => {
                    badges.push({
                        // @ts-ignore
                        onDeactivate: () => clearFilter(key, true, childKey),
                        // @ts-ignore
                        label: filterBadges[key][childKey](caseFilter, lang),
                    });
                });
                return;
            }
        }
        badges.push({
            // @ts-ignore
            onDeactivate: () => clearFilter(key),
            // @ts-ignore
            label: filterBadges[key](caseFilter, lang),
        });
    });
    return badges;
};
//# sourceMappingURL=selectors.js.map